import numeral from 'numeral';

export const percentage = value => numeral(value).format('0.00%');
export const percentage100 = value => numeral(value / 100).format('0.00%');
export const removeFloatZero = value => Number.isInteger(value) ? value : value?.toFixed(2);